(function () {
  function shuffleGrid() {
    const grid = document.querySelector('#product-grid');
    if (!grid || grid.dataset.shuffled) return;

    const items = Array.from(grid.children);

    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      grid.appendChild(items[j]);
    }

    grid.dataset.shuffled = 'true';
  }

  // intento inicial
  shuffleGrid();

  // observa cambios (filtros / load more / infinite scroll)
  const container = document.querySelector('#ProductGridContainer');
  if (!container) return;

  const observer = new MutationObserver(() => {
    shuffleGrid();
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
})();
